module.exports = __webpack_public_path__ + "img/P629205804.c05a9d18.jpg";